import * as THREE from 'three'
import { v } from 'src/vectorPaths/utils'
import {
  bracketInsert,
  bracketInsertNeck,
  adapterPlateThicknessInside,
  adapterPlateThicknessOutside
} from 'src/constants/parameters'
import { ContentEdge, Printedcircuitboard } from 'src/api/models/Content'
import { Instance } from 'mobx-state-tree'
import { Side, top, bottom } from 'src/constants/sides'

type GenerateBracketArg = {
  /** default bottom  */
  side: Extract<Side, typeof top | typeof bottom>
  /** left or right */
  globalPlateSide: Side
  node: { properties: Instance<ReturnType<typeof Printedcircuitboard>>['properties'] }
  properties: Instance<typeof ContentEdge>['properties']
}

const bracketTop = 5

export const generateBracketShape: (arg: GenerateBracketArg) => THREE.Shape = ({
  side,
  globalPlateSide,
  node,
  properties: { gap }
}) => {
  /** distance between adaper and printedcircuitboard */
  let interstace = 0
  let border = 3

  switch (side) {
    case top:
      interstace = node.properties.componentSide.height.value + gap.top.value
      break
    case bottom:
      interstace = node.properties.solderSide.height.value + gap.bottom.value
  }
  const bracketWidthFromCoverSide = gap[globalPlateSide].value + border
  const total = interstace + adapterPlateThicknessInside + adapterPlateThicknessOutside
  const path = v([
    [0, 0],
    [bracketInsert, 0],
    [bracketInsert, adapterPlateThicknessInside],
    [bracketInsertNeck, adapterPlateThicknessInside],
    [bracketInsertNeck, adapterPlateThicknessInside + adapterPlateThicknessOutside],
    // up the adapter
    [bracketWidthFromCoverSide, adapterPlateThicknessInside + adapterPlateThicknessOutside],
    // plate insert
    [bracketWidthFromCoverSide, adapterPlateThicknessInside + adapterPlateThicknessOutside + interstace],
    [bracketWidthFromCoverSide - border, adapterPlateThicknessInside + adapterPlateThicknessOutside + interstace],
    [
      bracketWidthFromCoverSide - border,
      adapterPlateThicknessInside + adapterPlateThicknessOutside + interstace + node.properties.thickness.value
    ],
    [
      bracketWidthFromCoverSide,
      adapterPlateThicknessInside + adapterPlateThicknessOutside + interstace + node.properties.thickness.value
    ],
    // top of the bracket
    [
      bracketWidthFromCoverSide,
      adapterPlateThicknessInside +
        adapterPlateThicknessOutside +
        interstace +
        node.properties.thickness.value +
        bracketTop
    ],
    [
      0,
      adapterPlateThicknessInside +
        adapterPlateThicknessOutside +
        interstace +
        node.properties.thickness.value +
        bracketTop
    ]
  ])
  return new THREE.Shape(path.getPoints())
}
